<template>
  <div>
    <DetailSheetHeader :title="$t('waypoint_dialog.waypoints.my_waypoints')" show-back @back="backClicked" />

    <div class="p-3">
      <input class="form-control rounded-pill" type="text" v-model="searchQuery" :placeholder="$t('waypoint_dialog.waypoints.search')" @input="runSearch" />

      <div v-for="waypoint in waypointsForList" :key="waypoint.id" class="mt-3">
        <div class="row">
          <div class="col-9">
            <p class="m-0 d-flex align-items-center">
              {{waypoint.title}}
            </p>
            <small class="text-muted d-flex align-items-center mt-1">{{new Date(waypoint.createdAt).toLocaleDateString()}} - {{new Date(waypoint.createdAt).toLocaleTimeString()}}
              <span class="mx-2">&middot;</span>
              <span role="button" class="text-muted d-flex align-items-center" @click="exportWaypointToGPX(waypoint)">GPX <span class="material-icons ml-1" style="font-size: 17px;">download</span></span>
              <span class="mx-2">&middot;</span>
              <span role="button" class="text-muted d-flex align-items-center" @click="deleteWaypoint(waypoint)">{{ $t('waypoint_dialog.waypoints.delete') }} <span class="material-icons ml-1" style="font-size: 17px;">delete</span></span>
            </small>
          </div>
          <div class="col-3">
            <button class="btn btn-block btn-xs btn-secondary" style="max-height: 34px;" @click="showWaypointOnMap(waypoint)">{{ $t('waypoint_dialog.waypoints.show') }}</button>
          </div>
        </div>
        <hr class="my-2">
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import DetailSheetHeader from '../../../utils/shared_components/detail_sheet/DetailSheetHeader.vue';

export default defineComponent({
  components: { DetailSheetHeader },
  data() {
    return {
      searchQuery: '',
    };
  },
  mounted() {
    this.runSearch();
  },
  computed: Object.assign(mapGetters({
    waypointsForList: 'waypoints/waypointsForList',
  })),
  methods: {
    async runSearch() {
      await this.$store.dispatch('waypoints/searchWaypoints', this.searchQuery);
    },
    backClicked() {
      this.$store.commit('waypoints/popPage');
    },
    showWaypointOnMap(waypoint) {
      this.$store.dispatch('waypoints/showWaypointOnMap', waypoint);
    },
    exportWaypointToGPX(waypoint) {
      this.$store.dispatch('waypoints/exportWaypointToGPX', waypoint);
    },
    async deleteWaypoint(waypoint) {
      await this.$store.dispatch('waypoints/deleteWaypoint', waypoint);
      await this.runSearch();
    },
  },
});
</script>
